export default {
  GET_MAINTENANCE_RECORDS: ({ page = 1, rowsPerPage = 10 }) => `maintenance/?page=${page}&page_size=${rowsPerPage}`,
  SEARCH_MAINTENANCE_RECORDS: ({ page = 1, rowsPerPage = 10, searchTerm, startDate, endDate }) =>
    `maintenance/?page=${page}&page_size=${rowsPerPage}${(searchTerm !== '' && `&search_term=${searchTerm}`) || ''}${
      (startDate !== '' && `&start_date=${startDate}`) || ''
    }${(endDate !== '' && `&end_date=${endDate}`) || ''}`,
  GET_ONSITE_MAINTENANCE_RECORDS: ({ page = 1, rowsPerPage = 10 }) =>
    `maintenance/onsite?page=${page}&page_size=${rowsPerPage}`,
  GET_OFFSITE_MAINTENANCE_RECORDS: ({ page = 1, rowsPerPage = 10 }) =>
    `maintenance/offsite?page=${page}&page_size=${rowsPerPage}`,
  GET_ASSET_MAINTENANCE_RECORDS: ({ id, page = 1, rowsPerPage = 10 }) =>
    `maintenance/?asset_id=${id}&page=${page}&page_size=${rowsPerPage}`,
  GET_MAINTENANCE_RECORD: (id) => `maintenance/${id}`,
  CREATE_MAINTENANCE_RECORD: 'maintenance/',
  // PATCH the request itself: provider (or in-house), type, venue, date, description.
  UPDATE_MAINTENANCE_RECORD: (id) => `maintenance/${id}`,
  CREATE_REPAIR_RECORD: 'maintenance/repairs/',
  UPDATE_REPAIR_RECORD: (id) => `maintenance/repairs/${id}/`,
  DELETE_REPAIR_RECORD: (id) => `maintenance/repairs/${id}/`,
  JOB_CARD: (id) => `maintenance/${id}/job-card/`,
  GET_REPAIR_DETAIL: (id, { page = 1, rowsPerPage = 10 } = {}) =>
    `maintenance/repairs/?maintenance_id=${id}&page=${page}&page_size=${rowsPerPage}`,
  UPDATE_STATUS: (id) => `maintenance/${id}/status`,
  APPROVE_MAINTENANCE: (id) => `maintenance/${id}/approve-maintenance`,
  DECLINE_MAINTENANCE: (id) => `maintenance/${id}/decline-maintenance`,
  RETURN_REQUEST: (id) => `maintenance/${id}/return-request/`,
  ACCEPT_RETURN_REQUEST: (id) => `maintenance/${id}/return-request/accept/`,
  DECLINE_RETURN_REQUEST: (id) => `maintenance/${id}/return-request/decline/`,
  SP_REPAIR_ACCEPTANCE: (id) => `maintenance/${id}/service-provider/accept/`,
  SP_REPAIR_DECLINE: (id) => `maintenance/${id}/service-provider/decline/`,
};
